/**
 * Base Environment Configuration
 *
 * This file contains the shared Environment interface and base configuration.
 * All environment-specific files should import from this file.
 */

/** Dokploy production API (HTTPS via reverse proxy to backend :8080). */
export const deployedApiUrl = 'https://api.app-doctor.io';

/** Dokploy staging API. */
export const stagingApiUrl = 'https://staging-api.app-doctor.io';

export interface Environment {
  production: boolean;
  environmentName: string;
  apiUrl: string;
  apiTimeout: number;
  enableDebugTools: boolean;
  enableAnalytics: boolean;
  enableServiceWorker: boolean;
  /** When true, all backend HTTP traffic is intercepted and served from in-memory demo data. */
  demo: boolean;
  /** Google Identity Services OAuth client ID (public, safe to commit). */
  googleClientId: string;
  /** LinkedIn "Sign In with LinkedIn using OpenID Connect" app client ID (public, safe to commit). */
  linkedinClientId: string;
  features: {
    enableDarkMode: boolean;
    enableNotifications: boolean;
    enableChatbot: boolean;
    enableOfflineMode: boolean;
  };
  logging: {
    enableConsoleLogging: boolean;
    enableErrorTracking: boolean;
    sentryDsn?: string;
  };
  auth: {
    tokenRefreshBuffer: number; // seconds before expiry to refresh
    sessionTimeout: number; // minutes
    enableGuards: boolean; // Enable/disable route guards
  };
}

export const baseEnvironment: Partial<Environment> = {
  apiUrl: deployedApiUrl,
  apiTimeout: 30000,
  demo: false,
  googleClientId: '626381053142-dd1daa7o95s8hnlkne5g6qmfrgvnagq1.apps.googleusercontent.com',
  linkedinClientId: '788gpix6jlz0dn',
  auth: {
    tokenRefreshBuffer: 300, // 5 minutes
    sessionTimeout: 30, // 30 minutes
    enableGuards: true // Enable guards by default
  },
  features: {
    enableDarkMode: false,
    enableNotifications: true,
    enableChatbot: false,
    enableOfflineMode: false
  }
};



